import { Attributes, List, ModelBase, NeoModel } from "@singularsystems/neo-core";
import StaticServiceProviderImportStatusModel from "./StaticServiceProviderImportStatusModel";
// Level one - just dates
@NeoModel
export default class StaticServiceProviderImportDatesModel extends ModelBase {

    @Attributes.Date()
    public dateReport: Date = new Date();

    public staticServiceProviderImportStatusModel = new List(StaticServiceProviderImportStatusModel) ;
}